import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import {SessionService} from '@core/services/session.service';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PublicAuthGuard implements CanActivate, CanActivateChild {

    constructor(private _router: Router,
                private _session: SessionService) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // If the user is an admin don't give access.
        if (this._session.isAdmin || this._session.isAgent) {
            this._router.navigate(['/admin']).then(_ => _);
            return false;
        }

        return true;
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.canActivate(childRoute, state);
    }

}
